import { EventengineStopStackTracesService_stopStackTraceServiceGetEntity } from '@festina/legalentity-general-types/legalentity/hooks/EventengineStopStackTracesService_stopStackTraceServiceGetEntity'

export const useFetchLegalEntityStackTrace =
  EventengineStopStackTracesService_stopStackTraceServiceGetEntity.useSuspenseQuery
